/*
 * Module for the New Benefits Estimate page
*/
rs.module("ui/content/benefits/estimates/new",

    [
        "common/select-helper",
        "controls/components/event-banner",
    ],

    function (selectHelper, eventBanner) {
        // Initialize the module
        function initialize(jsSelectors, separationTypes, backendUrls) {

            // Unpack Js Selectors
            var fundPicker = $.js(jsSelectors.fundPicker, { required: false });
            var newEstimateForm = $.js(jsSelectors.newEstimateForm);
            var separationTypeSelect = newEstimateForm.js(jsSelectors.separationTypeSelect);
            var separationDate = newEstimateForm.js(jsSelectors.separationDate);
            var benefitEffectiveDate = newEstimateForm.js(jsSelectors.benefitEffectiveDate);
            var separationSubTypeSelect = newEstimateForm.js(jsSelectors.separationSubTypeSelect);
            var backDropCheckbox = newEstimateForm.js(jsSelectors.backDropCheckbox);
            var backDropDate = newEstimateForm.js(jsSelectors.backDropDate);
            var backDropMonths = newEstimateForm.js(jsSelectors.backDropMonths);
            var retirementDetailsSection = newEstimateForm.js(jsSelectors.retirementDetailsSection);
            var dropPlanSection = newEstimateForm.js(jsSelectors.dropPlanSection);
            var dropPlanSelect = newEstimateForm.js(jsSelectors.dropPlanSelect);
            var dropEntryDate = newEstimateForm.js(jsSelectors.dropEntryDate);
            var backDropSection = newEstimateForm.js(jsSelectors.backDropSection);
            var backDropSectionDetails = newEstimateForm.js(jsSelectors.backDropSectionDetails);
            var fundKey = newEstimateForm.js(jsSelectors.fundKey);
            var loadingSpinner = $.js(jsSelectors.loadingSpinner);
            var beneficiaryCheckbox = $.js(jsSelectors.beneficiaryCheckbox);
            var beneficiarySection = $.js(jsSelectors.beneficiarySection);
            var salaryChangeCheckbox = $.js(jsSelectors.salaryChangeCheckbox);
            var salaryChangeSection = $.js(jsSelectors.salaryChangeSection);

            // The fields available on the form depend on which separation type is selected
            separationTypeSelect.change(function () {
                separationSubTypeSelect.toggle($(this).val() == separationTypes.disability);
                dropPlanSection.toggle($(this).val() == separationTypes.drop);
                retirementDetailsSection.toggle($(this).val() != separationTypes.drop);
                backDropSection.toggle($(this).val() == separationTypes.retirement);

                // This is the only checkbox that might not be on screen at all
                // Conditionally disable it to avoid mistakenly posting it
                backDropCheckbox.setDisabled($(this).val() != separationTypes.retirement)
            });

            // On the rare occasion the user has more than one relevant fund, we'll start the process over if they change funds
            fundPicker.change(function () {
                window.location.href = `${backendUrls.newEstimate}?fundKey=${fundPicker.val()}`;
            });

            // Show a loading spinner and "disable" fields when we submit
            newEstimateForm.submit(function (e) {

                // Clear event banner messages
                eventBanner.removeAllMessages();

                // Validate form before showing spinner and hiding fields
                var validator = $(this).validate();
                var isValid = validator.form();

                if (isValid) {
                    loadingSpinner.show();

                    // Prevent further interaction with the form
                    newEstimateForm.css("pointer-events", "none")
                    // Bootstrap's custom control toggles don't respond to pointer events, so manually unhook them
                    newEstimateForm.find(".custom-control-label").removeAttr("for")
                }
                else {
                    e.preventDefault();
                }
            })

            // When we change the separation date, we may need to update the Benefit Effective Date and BackDrop Date
            separationDate.change(_handleSeparationDateChange);

            // Show the BackDrop section if BackDrop is checked
            backDropCheckbox.change(function () {
                backDropSectionDetails.toggle($(this).val());
            });

            // Show the beneficiary info if include beneficiary is checked
            beneficiaryCheckbox.change(function () {
                beneficiarySection.toggle($(this).val());
            });

            // Toggle the salary change section if corresponding toggle is clicked
            salaryChangeCheckbox.change(function () {
                salaryChangeSection.toggle($(this).val());
            });

            // Update BackDROP Date when needed
            benefitEffectiveDate.change(_addBackDropMonths);
            backDropMonths.change(_addBackDropMonths);

            // Get drop plan select helper and bind event to refresh the options
            var dropPlanSelectHelper = selectHelper.getHelper(dropPlanSelect);
            dropEntryDate.change(_.debounce(_updateDropPlanSelect, 500));

            // Update BED and backDropDate when separation date is changed
            function _handleSeparationDateChange() {

                try {
                    var newDate = new Date($(separationDate).val());
                    newDate.setDate(newDate.getDate() + 1);
                    benefitEffectiveDate.val(newDate.toISODateString());

                    // Adjust backDropDate if needed
                    if (backDropCheckbox.val()) {
                        _addBackDropMonths();
                    }
                }
                catch { }
            }

            // Update BED based on the number of backDrop months
            function _addBackDropMonths() {
                var benefitEstimateDate = new Date($(benefitEffectiveDate).val());
                var isoDate = new Date(benefitEstimateDate.toISODateString());

                // Account for time zones so our BackDROP Date doesn't get the wrong day
                isoDate = new Date(isoDate.getTime() - isoDate.getTimezoneOffset() * -60000);
                isoDate.setMonth(isoDate.getMonth() - backDropMonths.val())

                var newDateStr = isoDate.toISODateString().split("-")
                backDropDate.html(`${newDateStr[1]}/${newDateStr[2]}/${newDateStr[0]}`);
            }

            // Update the drop plan select options based on new dropEntryDate
            function _updateDropPlanSelect() {

                dropPlanSelectHelper.loadOptionsFrom(backendUrls.getAvailableDropPlans,
                    { fundKey: fundKey.val(), dropPlanEntryDate: dropEntryDate.val() },
                    { withBlank: true, maintainSelection: true },
                    function () {
                        if (this.getOptions().length > 0) {
                            eventBanner.removeErrorMessages();
                        }
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);